var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 8.33341H3.33366C2.41283 8.33341 1.66699 7.58758 1.66699 6.66675V3.33341C1.66699 2.41258 2.41283 1.66675 3.33366 1.66675H6.66699C7.58783 1.66675 8.33366 2.41258 8.33366 3.33341V6.66675C8.33366 7.58758 7.58783 8.33341 6.66699 8.33341Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 8.33341H13.3337C12.4128 8.33341 11.667 7.58758 11.667 6.66675V3.33341C11.667 2.41258 12.4128 1.66675 13.3337 1.66675H16.667C17.5878 1.66675 18.3337 2.41258 18.3337 3.33341V6.66675C18.3337 7.58758 17.5878 8.33341 16.667 8.33341Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 18.3334H3.33366C2.41283 18.3334 1.66699 17.5876 1.66699 16.6667V13.3334C1.66699 12.4126 2.41283 11.6667 3.33366 11.6667H6.66699C7.58783 11.6667 8.33366 12.4126 8.33366 13.3334V16.6667C8.33366 17.5876 7.58783 18.3334 6.66699 18.3334Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 18.3334H13.3337C12.4128 18.3334 11.667 17.5876 11.667 16.6667V13.3334C11.667 12.4126 12.4128 11.6667 13.3337 11.6667H16.667C17.5878 11.6667 18.3337 12.4126 18.3337 13.3334V16.6667C18.3337 17.5876 17.5878 18.3334 16.667 18.3334Z",
    stroke: "#7F8585",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.f881886ddf710555cc40cd837ad94101.svg";
export { ForwardRef as ReactComponent };